import {
  BarChart3,
  Bath,
  Bed,
  BedDouble,
  Boxes,
  BriefcaseMedical,
  Building2,
  CircleDollarSign,
  ClipboardCheck,
  Clock,
  FileCheck2,
  FileText,
  Globe2,
  Hand,
  Handshake,
  HeartPulse,
  Hospital,
  Lock,
  Mail,
  MapPin,
  Microscope,
  Package,
  PackageCheck,
  Phone,
  RefreshCcw,
  Scissors,
  Search,
  Shield,
  ShieldCheck,
  Shirt,
  Sparkles,
  Stethoscope,
  Tag,
  TrendingUp,
  Truck,
  Zap,
} from 'lucide-react';

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/products' },
  { label: 'Solutions', to: '/solutions' },
  { label: 'Compliance', to: '/compliance' },
  { label: 'Resources', to: '/resources' },
  { label: 'Contact', to: '/contact' },
];

export const stats = [
  { number: '$14.64B', label: 'Global market size in 2025', Icon: BarChart3, tone: 'blue' },
  { number: '$34.52B', label: 'Projected by 2034', Icon: TrendingUp, tone: 'teal' },
  { number: '~10%', label: 'Annual CAGR growth', Icon: Zap, tone: 'amber' },
  { number: '42%', label: 'North America market share', Icon: Globe2, tone: 'emerald' },
  { number: '49%', label: 'Outsourcing market share', Icon: Handshake, tone: 'blue' },
  { number: '500+', label: 'SKUs available', Icon: Boxes, tone: 'teal' },
];

export const productCategories = ['All', 'Bedding', 'Towels', 'Patient Wear', 'Specialty'];

export const products = [
  {
    name: 'Hospital Bed Sheets',
    cat: 'Bedding',
    Icon: BedDouble,
    material: 'Cotton/poly blend',
    spec: '250 TC, percale weave',
    sizes: 'Twin, full, queen, king',
    feature: 'Fluid resistant',
    badge: 'Best seller',
    tone: 'blue',
    price: '$8.99',
    image: '/assets/products/bedding.png',
  },
  {
    name: 'Fitted Bed Sheets',
    cat: 'Bedding',
    Icon: Bed,
    material: 'Knitted cotton',
    spec: '180 TC, knit weave',
    sizes: 'Twin, full, hospital size',
    feature: 'Easy laundering',
    badge: 'New',
    tone: 'amber',
    price: '$7.49',
    image: '/assets/products/bedding.png',
  },
  {
    name: 'Pillowcases',
    cat: 'Bedding',
    Icon: Bed,
    material: 'Percale weave',
    spec: 'Standard and king sizes',
    sizes: 'Standard, king',
    feature: 'Hypo-allergenic',
    badge: 'Top pick',
    tone: 'teal',
    price: '$3.99',
    image: '/assets/products/bedding.png',
  },
  {
    name: 'Blankets & Bed Covers',
    cat: 'Bedding',
    Icon: Sparkles,
    material: 'Poly-cotton',
    spec: 'Thermal and standard',
    sizes: 'Twin, full, queen',
    feature: 'Washable 200+ cycles',
    badge: '',
    tone: 'emerald',
    price: '$14.99',
    image: '/assets/products/bedding.png',
  },
  {
    name: 'Bath Towels',
    cat: 'Towels',
    Icon: Bath,
    material: 'Woven cotton',
    spec: '400 GSM, absorbent',
    sizes: '27 x 54 in, 30 x 60 in',
    feature: 'Soft and durable',
    badge: 'Best seller',
    tone: 'blue',
    price: '$5.49',
    image: '/assets/products/towels.png',
  },
  {
    name: 'Hand Towels',
    cat: 'Towels',
    Icon: Hand,
    material: 'Terry cotton',
    spec: '360 GSM, loop pile',
    sizes: '16 x 27 in',
    feature: 'Fast drying',
    badge: '',
    tone: 'teal',
    price: '$2.99',
    image: '/assets/products/towels.png',
  },
  {
    name: 'OR Surgical Towels',
    cat: 'Towels',
    Icon: Microscope,
    material: 'Non-woven',
    spec: 'Sterile, single use',
    sizes: 'Standard OR size',
    feature: 'Fluid resistant',
    badge: 'Clinical grade',
    tone: 'amber',
    price: '$12.99',
    image: '/assets/products/towels.png',
  },
  {
    name: 'Washcloths',
    cat: 'Towels',
    Icon: Bath,
    material: 'Woven terry',
    spec: '300 GSM, soft',
    sizes: '12 x 12 in',
    feature: 'Hygienic weave',
    badge: '',
    tone: 'emerald',
    price: '$1.99',
    image: '/assets/products/towels.png',
  },
  {
    name: 'Patient Gowns',
    cat: 'Patient Wear',
    Icon: Shirt,
    material: 'Cotton muslin',
    spec: 'Tie or snap closure',
    sizes: 'S, M, L, XL, 2XL',
    feature: 'Dignity design',
    badge: 'New',
    tone: 'emerald',
    price: '$6.99',
    image: '/assets/products/patient-wear.png',
  },
  {
    name: 'Repositioners',
    cat: 'Patient Wear',
    Icon: RefreshCcw,
    material: 'Non-woven poly',
    spec: 'Slide and turn design',
    sizes: 'Standard',
    feature: 'Reduces staff injury',
    badge: '',
    tone: 'blue',
    price: '$9.49',
    image: '/assets/products/patient-wear.png',
  },
  {
    name: 'Incontinence Products',
    cat: 'Specialty',
    Icon: Shield,
    material: 'Non-woven composite',
    spec: 'Waterproof backing',
    sizes: 'Various',
    feature: 'Odor control',
    badge: '',
    tone: 'teal',
    price: '$4.99',
    image: '/assets/products/specialty.png',
  },
  {
    name: 'Non-Woven Disposables',
    cat: 'Specialty',
    Icon: Package,
    material: 'PP non-woven',
    spec: 'Surgical grade',
    sizes: 'Bulk pack',
    feature: 'Single-use safe',
    badge: 'Trending',
    tone: 'amber',
    price: '$18.99',
    image: '/assets/products/specialty.png',
  },
];

export const solutions = [
  {
    Icon: Hospital,
    title: 'Hospitals & Health Systems',
    desc: 'Bulk contracts for large health systems requiring consistent supply of bed sheets, OR towels, and patient gowns across multiple departments and floors.',
    features: ['High-volume bulk orders', 'Department-level inventory tracking', 'Just-in-time delivery', 'Custom hospital branding'],
    tone: 'blue',
  },
  {
    Icon: Building2,
    title: 'Long-Term Care Facilities',
    desc: 'Soft, durable, patient-comfort-focused linens for nursing homes, rehabilitation centers, and assisted living facilities.',
    features: ['Comfort-first cotton blends', 'Hypo-allergenic options', 'Easy laundering fabrics', 'Bulk pricing tiers'],
    tone: 'emerald',
  },
  {
    Icon: Stethoscope,
    title: 'Diagnostic & Specialty Clinics',
    desc: 'Non-woven and woven linens for outpatient clinics, diagnostic centers, and specialty practices with moderate volume needs.',
    features: ['Flexible order quantities', 'Single-use non-woven options', 'Fast reordering portal', 'Compliance documentation'],
    tone: 'teal',
  },
  {
    Icon: Scissors,
    title: 'Surgical & OR Centers',
    desc: 'Sterile-grade OR towels, fluid-resistant surgical drapes, and non-woven disposables designed for operating room environments.',
    features: ['Sterile packaging available', 'Fluid-resistant materials', 'HLAC-partner laundering', 'Traceability and audit readiness'],
    tone: 'amber',
  },
];

export const standards = [
  {
    code: 'CDC',
    full: 'Centers for Disease Control',
    Icon: Microscope,
    tone: 'blue',
    points: ['Hygienically clean linen protocols', 'Proper soil removal and pathogen inactivation', 'Contaminated item bagging and labeling', 'No sorting or rinsing at point of use'],
  },
  {
    code: 'OSHA',
    full: 'Occupational Safety & Health Admin.',
    Icon: ShieldCheck,
    tone: 'emerald',
    points: ['PPE requirements for contaminated laundry', 'Containment and handling procedures', 'Prohibition of home laundering of clinical items', 'Bloodborne pathogen standard compliance'],
  },
  {
    code: 'HLAC',
    full: 'Healthcare Laundry Accreditation Council',
    Icon: FileCheck2,
    tone: 'teal',
    points: ['Accredited laundry partner network', 'Processing standards for healthcare textiles', 'Audit trail and traceability systems', 'Regular facility inspections'],
  },
  {
    code: 'FDA',
    full: 'Food & Drug Administration Textiles',
    Icon: ClipboardCheck,
    tone: 'amber',
    points: ['Material safety for patient-contact textiles', 'Fluid-resistant barrier standards', 'Non-woven surgical textile requirements', 'Documentation for audit readiness'],
  },
];

export const complianceDocs = [
  { title: 'CDC Linen Handling Guide', href: '/docs/cdc-linen-handling-guide.txt', Icon: FileText },
  { title: 'OSHA Bloodborne Pathogen Standard', href: '/docs/osha-bloodborne-pathogen-standard.txt', Icon: ShieldCheck },
  { title: 'HLAC Accreditation Overview', href: '/docs/hlac-accreditation-overview.txt', Icon: FileCheck2 },
  { title: 'NCL Quality Assurance Sheet', href: '/docs/ncl-quality-assurance-sheet.txt', Icon: ClipboardCheck },
];

export const articles = [
  {
    tag: 'Infection Control',
    Icon: Microscope,
    title: 'CDC Guidelines for Hospital Linen Handling',
    desc: 'A complete breakdown of CDC-recommended protocols for contaminated linen collection, transport, and processing in healthcare settings.',
    read: '5 min read',
    date: 'May 14, 2026',
  },
  {
    tag: 'Operations',
    Icon: Truck,
    title: 'How Just-in-Time Linen Delivery Reduces Costs',
    desc: 'Case study: How mid-size hospitals reduced linen costs by 23% through scheduled bulk delivery and on-demand reordering portals.',
    read: '7 min read',
    date: 'April 29, 2026',
  },
  {
    tag: 'Compliance',
    Icon: ClipboardCheck,
    title: 'HLAC Accreditation: What Hospitals Must Know',
    desc: 'Understanding HLAC standards for healthcare laundry partners and why choosing accredited processors protects your facility from liability.',
    read: '6 min read',
    date: 'March 18, 2026',
  },
  {
    tag: 'Procurement',
    Icon: CircleDollarSign,
    title: 'GPO vs. Direct Procurement: Which Saves More?',
    desc: 'Breaking down the cost math of Group Purchasing Organization contracts versus direct supplier relationships for hospital linen supply.',
    read: '8 min read',
    date: 'February 26, 2026',
  },
  {
    tag: 'Materials',
    Icon: Shirt,
    title: 'Woven vs. Non-Woven: Choosing the Right Linen',
    desc: 'Thread counts, GSM, fluid resistance, and laundering cycles for selecting the right textile for each clinical department.',
    read: '6 min read',
    date: 'January 22, 2026',
  },
  {
    tag: 'Industry',
    Icon: TrendingUp,
    title: 'Hospital Linen Market: 2025-2034 Growth Outlook',
    desc: 'Market analysis: Why the global hospital linen supply market is heading toward $34.5 billion and what it means for healthcare procurement teams.',
    read: '4 min read',
    date: 'December 11, 2025',
  },
];

export const whyReasons = [
  { Icon: Search, title: 'Niche Specialization', desc: 'We focus exclusively on healthcare linens, not general facility supplies. Every product is designed for clinical environments.' },
  { Icon: Truck, title: 'Just-in-Time Delivery', desc: 'Regional warehouse coverage supports rapid fulfillment during high-admission periods and seasonal demand swings.' },
  { Icon: BriefcaseMedical, title: 'B2B E-Commerce Portal', desc: 'One-click reorders, order history, custom pricing contracts, and approval workflows live in the account dashboard.' },
  { Icon: Tag, title: 'Custom Hospital Branding', desc: 'Add facility names, logos, or color coding to standardize the patient experience across departments.' },
  { Icon: BarChart3, title: 'Inventory Management', desc: 'Track stock levels, set reorder triggers, and receive low-stock alerts with ERP-friendly reporting.' },
  { Icon: Handshake, title: 'GPO Partnership Pricing', desc: 'Registered with major Group Purchasing Organizations for health systems that rely on negotiated contract pricing.' },
  { Icon: Lock, title: 'Full Compliance Support', desc: 'Compliance documentation, audit trails, and certifications stay ready for procurement and infection-control teams.' },
  { Icon: CircleDollarSign, title: 'Net-30 & Bulk Pricing', desc: 'Flexible payment terms for qualified accounts and tiered volume pricing that scales with facility needs.' },
];

export const comparisonRows = [
  ['Healthcare-only specialization', true, false],
  ['Online B2B reorder portal', true, false],
  ['Custom facility branding', true, false],
  ['GPO partnership pricing', true, true],
  ['Compliance documentation', true, 'Partial'],
  ['Just-in-time delivery', true, false],
  ['Net-30 payment terms', true, true],
  ['Dedicated account manager', true, false],
];

export const contactDetails = [
  { Icon: Mail, label: 'Email', value: 'procurement@novacarelinens.com' },
  { Icon: Phone, label: 'Phone', value: '1-800-NCL-LINEN' },
  { Icon: MapPin, label: 'Headquarters', value: 'Regional distribution centers, USA' },
  { Icon: Clock, label: 'Response Time', value: 'Within 24 business hours' },
];

export const trustPillars = [
  { Icon: ShieldCheck, title: 'CDC aligned handling', text: 'Written linen protocols for collection, containment, and transport.' },
  { Icon: PackageCheck, title: 'Audit-ready SKUs', text: 'Product specs, material data, and account documentation kept together.' },
  { Icon: HeartPulse, title: 'Patient comfort', text: 'Textiles selected for repeated laundering without losing softness.' },
  { Icon: Truck, title: 'Reliable supply', text: 'Bulk programs built around usage patterns, storage limits, and census changes.' },
];
